import React from 'react'
import { FormResistance } from './FormResistance';
import { Dialog } from 'primereact/dialog';

export const ModalResistance = (props) => {

    const {
        modal, tittle, closeDialogM, method,
        name,
        handleInputChange, loading,
        saveCreateDiscounts,saveUpdateDiscount
    } = props;

    return (
        <Dialog 
            header={tittle}
            visible={modal}
            onHide={closeDialogM}
            closable={true}
            modal
            blockScroll
            className='medium-dialog'
        >
        
            {
                method === "create"
                    ? <FormResistance
                        button={"Crear"}
                        {...{ closeDialogM, loading,name, handleInputChange, methodAction: saveCreateDiscounts }}
                    />
                    : (method === "update")
                        ?
                        <FormResistance
                            button={"Actualizar"}
                            {...{ closeDialogM, loading,name, handleInputChange,methodAction: saveUpdateDiscount }} />
                        :
                        null
            }
        </Dialog>
    )
}
